function base64ToBlob(base64, mime) {
  mime = mime || "";
  const sliceSize = 1024;
  const byteChars = window.atob(base64);
  const byteArrays = [];

  for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
    const slice = byteChars.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mime });
}

function parseFileData(dataURI: string) {
  const mimeString = dataURI
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];
  const base64 = dataURI.split(",")[1];

  return base64ToBlob(base64, mimeString);
}

export const toFormData = (schema: Object, dto: Object) => {
  const form = new FormData();

  Object.entries(dto).forEach(entry => {
    let key = entry[0];
    let value = entry[1];
    let schemaKey = schema.properties[key];

    if (typeof schemaKey != "undefined" && value != null && typeof value != "undefined") {
      if (value != null && typeof value === "string" && value.startsWith("data:")) {
        const fileData = parseFileData(value);
        const filename = value && value.split(";")[1].split("=")[1];

        form.append(key, fileData, filename);
      } else {
        // $FlowIgnore check this later
        form.append(key, value);
      }
    }
  });

  return form;
};
